import { logErrorToConsole } from '../../constants';

const isValidUrl = (url) => {
  try {
    if (!url) return false;
    const parsed = new URL(url);
    return ['http:', 'https:'].includes(parsed.protocol);
  } catch (error) {
    logErrorToConsole('[ERROR] occured in isValidUrl: ', error);
    return false;
  }
};

export default isValidUrl;
